import {
  DOWNLOAD_ISO_MATERIAL_CSV,
  DOWNLOAD_ISO_MATERIAL_PDF,
  DOWNLOAD_ISO_WELD_LOG_CSV,
  DOWNLOAD_ISO_WELD_LOG_PDF,
  DOWNLOAD_NCR_REPORT_PDF,
  DOWNLOAD_PROJECT_REPORT_PDF,
  DOWNLOAD_WELDING_GAS_CSV,
  DOWNLOAD_WELDING_MACHINE_CSV,
  DOWNLOAD_WELDING_WPQ_CSV,
  ISO_MATERIAL_FORM_LIST,
  ISO_METERIAL_FORM_DETAIL,
  ISO_WELD_LOG_FORM_LIST,
  NCR_REPORT_DETAIL,
  NCR_REPORT_LIST,
  PREVIEW_NCR_REPORT_PDF,
  PREVIEW_PROJECT_REPORT_PDF,
  PROJECT_REPORT_DETAIL,
  PROJECT_REPORT_LIST,
  WELDING_GAS_FORM_DETAIL,
  WELDING_GAS_FORM_LIST,
  WELDING_MACHINE_CALLIBRATION_FORM_DETAIL,
  WELDING_MACHINE_CALLIBRATION_LIST,
  WELDING_WPQ_LIST,
  WELDING_WPQ_LIST_FORM_DETAIL,
  WELD_LOG_FORM_DETAIL,
} from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchInspectionFailure,
  fetchInspectionStart,
  fetchInspectionSuccess,
  fetchWeldingGasStart,
  fetchWeldingGasSuccess,
  fetchWeldingGasFailure,
  fetchWeldingMachineCallibrationStart,
  fetchWeldingMachineCallibrationSuccess,
  fetchWeldingMachineCallibrationFailure,
  fetchWeldingWPQStart,
  fetchWeldingWPQSuccess,
  fetchWeldingWPQFailure,
  fetchWeldLogStart,
  fetchWeldLogSuccess,
  fetchWeldLogFailure,
  fetchProjectReportStart,
  fetchProjectReportSuccess,
  fetchProjectReportFailure,
  fetchIsoMaterialDetailsStart,
  fetchIsoMaterialDetailsSuccess,
  fetchIsoMaterialDetailsFailure,
  fetchWeldingGasDetailsStart,
  fetchWeldingGasDetailsSuccess,
  fetchWeldingGasDetailsFailure,
  fetchWeldMachineCalibDetailsStart,
  fetchWeldMachineCalibDetailsSuccess,
  fetchWeldMachineCalibDetailsFailure,
  fetchWeldingWPQDetailsStart,
  fetchWeldingWPQDetailsSuccess,
  fetchWeldingWPQDetailsFailure,
  fetchWeldLogDetailsStart,
  fetchWeldLogDetailsSuccess,
  fetchWeldLogDetailsFailure,
  deleteProjectReportStart,
  deleteProjectReportSuccess,
  deleteProjectReportFailure,
  deleteWeldLogStart,
  deleteWeldLogSuccess,
  deleteWeldLogFailure,
  deleteWeldMachineCaliFailure,
  deleteWeldMachineCaliStart,
  deleteWeldMachineCaliSuccess,
  deleteWeldingWPQFailure,
  deleteWeldingWPQStart,
  deleteWeldingWPQSuccess,
  deleteWeldingGasStart,
  deleteWeldingGasFailure,
  deleteWeldingGasSuccess,
  deleteIsoMaterialFailure,
  deleteIsoMaterialStart,
  deleteIsoMaterialSuccess,
  previewPdfStart,
  previewPdfSuccess,
  previewPdfFailure,
  downloadPdfStart,
  downloadPdfSuccess,
  downloadPdfFailure,
  downloadIsomaterialPdfStart,
  downloadIsomaterialPdfSuccess,
  downloadIsomaterialPdfFailure,
  fetchNcrReportStart,
  fetchNcrReportSuccess,
  fetchNcrReportFailure,
  fetchProjectDetailsStart,
  fetchProjectDetailsSuccess,
  fetchProjectDetailsFailure,
  fetchNcrDetailsStart,
  fetchNcrDetailsSuccess,
  fetchNcrDetailsFailure,
  deleteNcrReportStart,
  deleteNcrReportSuccess,
  deleteNcrReportFailure,
  previewNcrPdfStart,
  previewNcrPdfSuccess,
  previewNcrPdfFailure,
  downloadNcrPdfStart,
  downloadNcrPdfSuccess,
  downloadNcrPdfFailure,
  downloadIsoWeldLogPdfStart,
  downloadIsoWeldLogPdfSuccess,
  downloadIsoWeldLogPdfFailure,
  fetchWeldingMachineDownloadCSVStart,
  fetchWeldingMachineDownloadCSVSuccess,
  fetchWeldingMachineDownloadCSVFailure,
  fetchWeldingWPQDownloadCSVStart,
  fetchWeldingWPQDownloadCSVSuccess,
  fetchWeldingWPQDownloadCSVFailure,
  fetchWeldLogDownloadCSVStart,
  fetchWeldLogDownloadCSVSuccess,
  fetchWeldLogDownloadCSVFailure,
  fetchWeldingGasDownloadCSVStart,
  fetchWeldingGasDownloadCSVSuccess,
  fetchWeldingGasDownloadCSVFailure,
  fetchIsoMaterialDownloadCSVStart,
  fetchIsoMaterialDownloadCSVSuccess,
  fetchIsoMaterialDownloadCSVFailure,
} from "../../reducer/InspectonDetailReducer/InspectionDetailReducer";

let isGetIsometricMaterialDetails = false;
let isGetWeldingGasDetails = false;
let isGetWeldMachineCalibDetails = false;
let isGetWeldWPQDetails = false;
let isGetWeldLogDetails = false;
let isGetProjectReportDetails = false;
let isGetNcrReportDetails = false;

let isGetInspectionList = false;
let isGetWeldingGasList = false;
let isGetWeldingMachineCalibartionList = false;
let isGetWeldingWPQList = false;
let isGetWeldLogList = false;
let isGetProjectReportList = false;
let isGetNcrReportList = false;

let isDownloadIsomaterialCSV = false;
let isDownloadWeldingMachineCSV = false;
let isDownloadWeldGasCSV = false;
let isDownloadWeldLogCSV = false;
let isDownloadWeldingWPQCSV = false;

const constructParams = (filters, projectId) => {
  const params = { project_id: projectId };

  if (filters.status && filters.status.length > 0) {
    filters.status.forEach((status, index) => {
      params[`form_status[${index}]`] = status;
    });
  }
  if (filters.dateRange) {
    params["dateStart"] = filters.dateRange.start || "";
    params["dateEnd"] = filters.dateRange.end || "";
  }

  const fields = [
    "inspectorName",
    "location",
    "weldSize",
    "masterType",
    "masterWelder",
    "weldType",
    "surfaceName",
    "tagID",
    "receiving",
    "materialDescription",
    "heat",
    "number",
    "acceptanceCriiteria",
    "ref_number",
    "line",
    "certIdType",
    "welderId",
    "name",
    "pId",
    "lineNo",
    "system",
    "isoDrawNo",
  ];

  fields.forEach((field) => {
    if (filters[field] && filters[field].length > 0) {
      filters[field].forEach((item, index) => {
        params[`${field}[${index}]`] = item;
      });
    }
  });

  return params;
};
// .................. Get Inspection List..................

export const GetInspectionList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetInspectionList) return;
    isGetInspectionList = true;
    dispatch(fetchInspectionStart());

    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${ISO_MATERIAL_FORM_LIST}`, {
        params,
      });
      dispatch(
        fetchInspectionSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchInspectionFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetInspectionList = false;
    }
  };

// .............. Get Welding Gas List  .......................

export const GetWeldingGasList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetWeldingGasList) return;
    isGetWeldingGasList = true;
    dispatch(fetchWeldingGasStart());

    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }
      const response = await axiosInstance.get(`${WELDING_GAS_FORM_LIST}`, {
        params,
      });
      dispatch(
        fetchWeldingGasSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchWeldingGasFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetWeldingGasList = false;
    }
  };

// .............. Get Welding Machine Callibration List  .......................

export const GetWeldingMachineCalibartionList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetWeldingMachineCalibartionList) return;
    isGetWeldingMachineCalibartionList = true;
    dispatch(fetchWeldingMachineCallibrationStart());

    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }
      const response = await axiosInstance.get(
        `${WELDING_MACHINE_CALLIBRATION_LIST}`,
        {
          params,
        }
      );
      dispatch(
        fetchWeldingMachineCallibrationSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchWeldingMachineCallibrationFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetWeldingMachineCalibartionList = false;
    }
  };

// .............. Get Welding WPG List  .......................

export const GetWeldingWPQList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetWeldingWPQList) return;
    isGetWeldingWPQList = true;
    dispatch(fetchWeldingWPQStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${WELDING_WPQ_LIST}`, {
        params,
      });
      dispatch(
        fetchWeldingWPQSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchWeldingWPQFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetWeldingWPQList = false;
    }
  };

// .............. Get Weld Log from List  .......................

export const GetWeldLogList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetWeldLogList) return;
    isGetWeldLogList = true;
    dispatch(fetchWeldLogStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${ISO_WELD_LOG_FORM_LIST}`, {
        params,
      });
      dispatch(
        fetchWeldLogSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchWeldLogFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetWeldLogList = false;
    }
  };

// ..................... Get Ncr Report form ..............................

export const GetNcrReportList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetProjectReportList) return;
    isGetProjectReportList = true;
    dispatch(fetchNcrReportStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${NCR_REPORT_LIST}`, {
        params,
      });
      dispatch(
        fetchNcrReportSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchNcrReportFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetProjectReportList = false;
    }
  };

// ..................... Get Project Report form ..............................

export const GetProjectReportList =
  (currentPage, searchTerm, itemsPerPage, sortField, sortOrder, projectId) =>
  async (dispatch) => {
    if (isGetNcrReportList) return;
    isGetNcrReportList = true;
    dispatch(fetchProjectReportStart());
    try {
      const params = {
        page: currentPage,
        size: itemsPerPage,
        sort: sortField,
        order: sortOrder,
        project_id: projectId,
      };

      if (searchTerm && searchTerm.trim() !== "") {
        params.search = searchTerm;
      }

      const response = await axiosInstance.get(`${PROJECT_REPORT_LIST}`, {
        params,
      });
      dispatch(
        fetchProjectReportSuccess({
          data: response?.data?.result,
          totalCount: response?.data?.result?.totalCount,
        })
      );
    } catch (error) {
      dispatch(
        fetchProjectReportFailure(
          error.response ? error.response.data : "An error occurred"
        )
      );
    } finally {
      isGetNcrReportList = false;
    }
  };

// ................... View individual Isometric material form  in details................

export const GetIsometricMaterialDetails =
  (isometricId) => async (dispatch) => {
    if (isGetIsometricMaterialDetails) return;
    isGetIsometricMaterialDetails = true;
    dispatch(fetchIsoMaterialDetailsStart());
    try {
      const response = await axiosInstance.get(`${ISO_METERIAL_FORM_DETAIL}`, {
        params: { form_id: isometricId },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(fetchIsoMaterialDetailsSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(fetchIsoMaterialDetailsFailure(error.message));
    } finally {
      isGetIsometricMaterialDetails = false;
    }
  };

// ................... View individual Isometric material form  in details................

export const GetWeldingGasDetails = (weldingasId) => async (dispatch) => {
  if (isGetWeldingGasDetails) return;
  isGetWeldingGasDetails = true;
  dispatch(fetchWeldingGasDetailsStart());
  try {
    const response = await axiosInstance.get(`${WELDING_GAS_FORM_DETAIL}`, {
      params: { form_id: weldingasId },
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldingGasDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchWeldingGasDetailsFailure(error.message));
  } finally {
    isGetWeldingGasDetails = false;
  }
};

// ................... View individual Welding Machine Calliartion form  in details................

export const GetWeldMachineCalibDetails = (weldingasId) => async (dispatch) => {
  if (isGetWeldMachineCalibDetails) return;
  isGetWeldMachineCalibDetails = true;
  dispatch(fetchWeldMachineCalibDetailsStart());
  try {
    const response = await axiosInstance.get(
      `${WELDING_MACHINE_CALLIBRATION_FORM_DETAIL}`,
      {
        params: { form_id: weldingasId },
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldMachineCalibDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchWeldMachineCalibDetailsFailure(error.message));
  } finally {
    isGetWeldMachineCalibDetails = false;
  }
};

// ................... View individual Welding WPQ form  in details................

export const GetWeldWPQDetails = (weldingasId) => async (dispatch) => {
  if (isGetWeldWPQDetails) return;
  isGetWeldWPQDetails = true;
  dispatch(fetchWeldingWPQDetailsStart());
  try {
    const response = await axiosInstance.get(
      `${WELDING_WPQ_LIST_FORM_DETAIL}`,
      {
        params: { form_id: weldingasId },
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldingWPQDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchWeldingWPQDetailsFailure(error.message));
  } finally {
    isGetWeldWPQDetails = false;
  }
};

// ................... View individual Weld Log form  in details................

export const GetWeldLogDetails = (weldLogId, projectId) => async (dispatch) => {
  if (isGetWeldLogDetails) return;
  isGetWeldLogDetails = true;
  dispatch(fetchWeldLogDetailsStart());
  try {
    const response = await axiosInstance.get(`${WELD_LOG_FORM_DETAIL}`, {
      params: { form_id: weldLogId, project_id: projectId },
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldLogDetailsSuccess(response?.data?.result));
  } catch (error) {
    dispatch(fetchWeldLogDetailsFailure(error.message));
  } finally {
    isGetWeldLogDetails = false;
  }
};

// ................... View individual Ncr Report form  in details................

export const GetNcrReportDetails = (ncrReportId) => async (dispatch) => {
  if (isGetNcrReportDetails) return;
  isGetNcrReportDetails = true;
  dispatch(fetchNcrDetailsStart());
  try {
    const response = await axiosInstance.get(`${NCR_REPORT_DETAIL}`, {
      params: { form_id: ncrReportId },
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchNcrDetailsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchNcrDetailsFailure(error.message));
  } finally {
    isGetNcrReportDetails = false;
  }
};

// ................... View individual Project Report form  in details................

export const GetProjectReportDetails =
  (projectReportId) => async (dispatch) => {
    if (isGetProjectReportDetails) return;
    isGetProjectReportDetails = true;
    dispatch(fetchProjectDetailsStart());
    try {
      const response = await axiosInstance.get(`${PROJECT_REPORT_DETAIL}`, {
        params: { form_id: projectReportId },
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(fetchProjectDetailsSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(fetchProjectDetailsFailure(error.message));
    } finally {
      isGetProjectReportDetails = false;
    }
  };

// ................... Delete individual Welding WPQ data................

export const deleteWeldWPQDetails = (weldingasId) => async (dispatch) => {
  dispatch(deleteWeldingWPQStart());
  try {
    const response = await axiosInstance.delete(
      `${WELDING_WPQ_LIST_FORM_DETAIL}?form_id=${weldingasId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(deleteWeldingWPQSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(deleteWeldingWPQFailure(error.message));
  }
};

// ................... Delete individual Weld Machine Calliibration data................

export const deleteWeldMachineDetails =
  (weldingmachineId) => async (dispatch) => {
    dispatch(deleteWeldMachineCaliStart());
    try {
      const response = await axiosInstance.delete(
        `${WELDING_MACHINE_CALLIBRATION_FORM_DETAIL}?form_id=${weldingmachineId}`
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(deleteWeldMachineCaliSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(deleteWeldMachineCaliFailure(error.message));
    }
  };

// // ................... Delete individual Welding Gas data................

export const deleteWeldingGasDetails = (weldingGasId) => async (dispatch) => {
  dispatch(deleteWeldingGasStart());
  try {
    const response = await axiosInstance.delete(
      `${WELDING_GAS_FORM_DETAIL}?form_id=${weldingGasId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(deleteWeldingGasSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(deleteWeldingGasFailure(error.message));
  }
};

// // ................... Delete individual Iso material data................

export const deleteIsoMaterialDetails = (isoMaterialId) => async (dispatch) => {
  dispatch(deleteIsoMaterialStart());
  try {
    const response = await axiosInstance.delete(
      `${ISO_METERIAL_FORM_DETAIL}?form_id=${isoMaterialId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(deleteIsoMaterialSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(deleteIsoMaterialFailure(error.message));
  }
};

// ................... Delete individual Weld Log data................

export const deleteWeldLogDetails = (weldLogId) => async (dispatch) => {
  dispatch(deleteWeldLogStart());
  try {
    const response = await axiosInstance.delete(
      `${WELD_LOG_FORM_DETAIL}?form_id=${weldLogId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(deleteWeldLogSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(deleteWeldLogFailure(error.message));
  }
};

// ................... Delete Ncr Report data................

export const deleteNcrReportDetails =
  (projectRepoortId) => async (dispatch) => {
    dispatch(deleteNcrReportStart());
    try {
      const response = await axiosInstance.delete(
        `${NCR_REPORT_DETAIL}?form_id=${projectRepoortId}`
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(deleteNcrReportSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(deleteNcrReportFailure(error.message));
    }
  };

// ................... Delete Project Report data................

export const deleteProjectReportDetails =
  (projectRepoortId) => async (dispatch) => {
    dispatch(deleteProjectReportStart());
    try {
      const response = await axiosInstance.delete(
        `${PROJECT_REPORT_DETAIL}?form_id=${projectRepoortId}`
      );

      if (response.status !== 200) {
        throw new Error("Failed to fetch inspector details.");
      }
      dispatch(deleteProjectReportSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching details:", error);
      dispatch(deleteProjectReportFailure(error.message));
    }
  };

// ...................... Get Preview Project Report Pdf .........................

export const previewProjectReportPdf = (previewId) => async (dispatch) => {
  dispatch(previewPdfStart());
  try {
    const response = await axiosInstance.get(`${PREVIEW_PROJECT_REPORT_PDF}`, {
      params: { form_id: previewId },
    });

    if (response.status === 200) {
      dispatch(previewPdfSuccess(response?.data));
      return response?.data;
    }
    throw new Error("Failed to fetch preview");
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(previewPdfFailure(error.message));
  }
};

// ...................... Download Preview Project Report Pdf .........................

export const downloadProjectReportPdf =
  (previewId, ref_no, { isZip = false}) =>
  async (dispatch) => {
    dispatch(downloadPdfStart());
    try {
      const response = await axiosInstance.get(
        `${DOWNLOAD_PROJECT_REPORT_PDF}`,
        {
          params: { form_id: previewId },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (isZip) {
          return blob;
        }
        const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        console.log("link", link);
        link.download = `${sanitizedFileName}.pdf`;
        // link.download = `${previewId}.pdf`;
        // link.download = `report.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        dispatch(downloadPdfSuccess(url));
        return true;
      }

      throw new Error("Failed to download PDF: Status not 200");
    } catch (error) {
      console.error("Error downloading PDF:", error);
      dispatch(downloadPdfFailure(error.message));
      return false;
    }
  };

// ....................... Download Isomaterial form pdf  .........................

export const downloadIsomaterialPdf =
  (previewId, ref_no, { isZip = false }) =>
  async (dispatch) => {
    dispatch(downloadIsomaterialPdfStart());
    try {
      const response = await axiosInstance.get(`${DOWNLOAD_ISO_MATERIAL_PDF}`, {
        params: { form_id: previewId },
        responseType: "blob",
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (isZip) {
          return blob;
        }
        const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${sanitizedFileName}.pdf`;
        // link.download = `${response?.config?.params?.form_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        dispatch(downloadIsomaterialPdfSuccess(url));
        return true;
      }
      throw new Error("Failed to download PDF: Status not 200");
    } catch (error) {
      console.error("Error downloading PDF:", error);
      dispatch(downloadIsomaterialPdfFailure(error.message));
      return false;
    }
  };

// ....................... Download Iso Weld Log form pdf  .........................

export const downloadIsoWeldLogPdf =
  (previewId, ref_no, { isZip = false }) => async (dispatch) => {
    dispatch(downloadIsoWeldLogPdfStart());
    try {
      const response = await axiosInstance.get(`${DOWNLOAD_ISO_WELD_LOG_PDF}`, {
        params: { form_id: previewId },
        responseType: "blob",
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (isZip) {
          return blob;
        }
        const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        console.log("link", link);
        link.download = `${sanitizedFileName}.pdf`;
        // link.download = `${response?.config?.params?.form_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        dispatch(downloadIsoWeldLogPdfSuccess(url));
        return true;
      }
      throw new Error("Failed to download PDF: Status not 200");
    } catch (error) {
      console.error("Error downloading PDF:", error);
      dispatch(downloadIsoWeldLogPdfFailure(error.message));
      return false;
    }
  };

// ...................... Get Preview Ncr Report Pdf .........................

export const previewNcrReportPdf = (previewId) => async (dispatch) => {
  dispatch(previewNcrPdfStart());
  try {
    const response = await axiosInstance.get(`${PREVIEW_NCR_REPORT_PDF}`, {
      params: { form_id: previewId },
    });

    if (response.status === 200) {
      dispatch(previewNcrPdfSuccess(response?.data));
      return response?.data;
    }
    throw new Error("Failed to fetch preview");
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(previewNcrPdfFailure(error.message));
  }
};

// ...................... Download Preview Ncr Report Pdf .........................

export const downloadNcrReportPdf = (previewId, ref_no, { isZip = false }) => async (dispatch) => {
  dispatch(downloadNcrPdfStart());
  try {
    const response = await axiosInstance.get(`${DOWNLOAD_NCR_REPORT_PDF}`, {
      params: { form_id: previewId },
      responseType: "blob",
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
       if (isZip) {
         return blob;
       }
      const sanitizedFileName = ref_no.replace(/[\/\\:*?"<>|]/g, "_");
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      console.log("link", link);
      link.download = `${ref_no}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch(downloadNcrPdfSuccess(url));
      return true;
    }

    throw new Error("Failed to download PDF: Status not 200");
  } catch (error) {
    console.error("Error downloading PDF:", error);
    dispatch(downloadNcrPdfFailure(error.message));
    return false;
  }
};

// ....................... Download Iso material csv ...........................

export const DownloadIsoMaterialCSV = (projectId, filters) => async (dispatch) => {
  if (isDownloadIsomaterialCSV) return;
  isDownloadIsomaterialCSV = true;
  dispatch(fetchIsoMaterialDownloadCSVStart());
  try {
    const response = await axiosInstance.post(`${DOWNLOAD_ISO_MATERIAL_CSV}`, {
      project_id: projectId,
      // ...filters,
      ...Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          return Array.isArray(value)
            ? value.length > 0
            : value !== undefined && value !== null && value !== "";
        })
      ),
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchIsoMaterialDownloadCSVSuccess(response?.data));
  } catch (error) {
    dispatch(
      fetchIsoMaterialDownloadCSVFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
  } finally {
    isDownloadIsomaterialCSV = false;
  }
};

//  ......................... Download Welding gas CSV .......................

export const DownloadWeldingGasCSV = (projectId, filters) => async (dispatch) => {
  if (isDownloadWeldGasCSV) return;
  isDownloadWeldGasCSV = true;
  dispatch(fetchWeldingGasDownloadCSVStart());
  try {
    const response = await axiosInstance.post(`${DOWNLOAD_WELDING_GAS_CSV}`, {
      project_id: projectId,
      ...Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          return Array.isArray(value)
            ? value.length > 0
            : value !== undefined && value !== null && value !== "";
        })
      ),
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldingGasDownloadCSVSuccess(response?.data));
  } catch (error) {
    dispatch(
      fetchWeldingGasDownloadCSVFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
  } finally {
    isDownloadWeldGasCSV = false;
  }
};

// ....................... Download Welding Machine csv ...........................

export const DownloadWeldingMachineCSV = (projectId, filters) => async (dispatch) => {
  if (isDownloadWeldingMachineCSV) return;
  isDownloadWeldingMachineCSV = true;
  dispatch(fetchWeldingMachineDownloadCSVStart());
  try {
    const response = await axiosInstance.post(
      `${DOWNLOAD_WELDING_MACHINE_CSV}`,
      {
        project_id: projectId,
        ...Object.fromEntries(
          Object.entries(filters).filter(([key, value]) => {
            return Array.isArray(value)
              ? value.length > 0
              : value !== undefined && value !== null && value !== "";
          })
        ),
      }
    );
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldingMachineDownloadCSVSuccess(response?.data));
  } catch (error) {
    dispatch(
      fetchWeldingMachineDownloadCSVFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
  } finally {
    isDownloadWeldingMachineCSV = false;
  }
};

//  ......................... Download ISO Weld Log CSV .......................

export const DownloadIsoWeldLogCSV = (projectId , filters) => async (dispatch) => {
  if (isDownloadWeldLogCSV) return;
  isDownloadWeldLogCSV = true;
  dispatch(fetchWeldLogDownloadCSVStart());
  try {
    const response = await axiosInstance.post(`${DOWNLOAD_ISO_WELD_LOG_CSV}`, {
      project_id: projectId,
      ...Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          return Array.isArray(value)
            ? value.length > 0
            : value !== undefined && value !== null && value !== "";
        })
      ),
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldLogDownloadCSVSuccess(response?.data));
  } catch (error) {
    dispatch(
      fetchWeldLogDownloadCSVFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
  } finally {
    isDownloadWeldLogCSV = false;
  }
};

//  ......................... Download Welding WPQ CSV .......................

export const DownloadWeldingWPQCSV = (projectId, filters) => async (dispatch) => {
  if (isDownloadWeldingWPQCSV) return;
  isDownloadWeldingWPQCSV = true;
  dispatch(fetchWeldingWPQDownloadCSVStart());
  try {
    const response = await axiosInstance.post(`${DOWNLOAD_WELDING_WPQ_CSV}`, {
      project_id: projectId,
      ...Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          return Array.isArray(value)
            ? value.length > 0
            : value !== undefined && value !== null && value !== "";
        })
      ),
    });
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchWeldingWPQDownloadCSVSuccess(response?.data));
  } catch (error) {
    dispatch(
      fetchWeldingWPQDownloadCSVFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
  } finally {
    isDownloadWeldingWPQCSV = false;
  }
};